import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminListOwnerInquiries } from "../../lib/api";

export default function OwnersPanel() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminListOwnerInquiries()
      .then(setRows)
      .catch(() => toast.error("Could not load owner inquiries"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="owners-panel">
      <header className="mb-8">
        <p className="ed-overline mb-2">Inquiries</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-[var(--ed-ink)]">Property Owners</h1>
        <p className="text-[var(--ed-ink-muted)] text-sm mt-1.5">{rows.length} inquiry/inquiries from London property owners.</p>
      </header>

      {loading ? (
        <p className="text-[var(--ed-ink-muted)] py-16 text-center">Loading…</p>
      ) : rows.length === 0 ? (
        <div className="border border-dashed border-[var(--ed-rule)] rounded-sm p-16 text-center">
          <p className="text-[var(--ed-ink-muted)]">No owner inquiries yet.</p>
        </div>
      ) : (
        <div className="border border-[var(--ed-rule)] rounded-sm overflow-x-auto bg-[var(--ed-bg)]" data-testid="admin-owners">
          <table className="w-full text-sm">
            <thead className="bg-[var(--ed-paper)] text-[var(--ed-ink-muted)] text-[0.6rem] uppercase tracking-[0.22em]">
              <tr>
                <th className="text-left px-5 py-3">Created</th>
                <th className="text-left px-5 py-3">Owner</th>
                <th className="text-left px-5 py-3">Property</th>
                <th className="text-left px-5 py-3">Type</th>
                <th className="text-left px-5 py-3">Message</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((o) => (
                <tr key={o.id} className="border-t border-[var(--ed-rule)] text-[var(--ed-ink-soft)]">
                  <td className="px-5 py-3.5 text-[var(--ed-ink-muted)] text-xs whitespace-nowrap">{(o.created_at || "").slice(0, 10)}</td>
                  <td className="px-5 py-3.5">
                    <p className="text-[var(--ed-ink)]">{o.full_name}</p>
                    <p className="text-[var(--ed-ink-muted)] text-xs">{o.email} · {o.phone}</p>
                  </td>
                  <td className="px-5 py-3.5 text-xs">{o.property_address}</td>
                  <td className="px-5 py-3.5">{o.property_type}</td>
                  <td className="px-5 py-3.5 text-xs max-w-md truncate" title={o.message}>{o.message || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
